import store from '@/store'
import axios from "axios";
import Vue from 'vue'; // Импортируем сам Vue
import {
  getFirebaseMessagingServiceWorkerRegistration,
  isPushFeatureAvailable
} from "@/js/push-support.js";
import {
  applyLocalMessageEdit,
  applyLocalMessageReactions,
  clearRoomUnreadCount,
  persistReadStatus,
  sendStatusMessage,
  setLocalTypingState
} from "@/js/WebSocket.js";

let latestChatRequestKey = null;
let latestBlockingChatRequestKey = null;

function getConfiguredBotUserId() {
  const value = process.env.VUE_APP_CHAT_BOT_USER_ID;
  return value ? String(value) : null;
}

function getBotParticipant(room) {
  const botUserId = getConfiguredBotUserId();

  if (!botUserId || !room || !Array.isArray(room.users)) {
    return null;
  }

  return room.users.find((user) => String(user && user._id) === botUserId) || null;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function getMessage(roomid, options = {}) {
  const {
    silentLoading = false,
    beforeId = null,
    appendOlder = false,
    autoScroll = !silentLoading,
  } = options;
  const requestKey = appendOlder ? null : `${roomid}:${Date.now()}`;

  if (!appendOlder) {
    latestChatRequestKey = requestKey;
  }

  // this.LoadingRule()
  if (!appendOlder && !silentLoading) {
    latestBlockingChatRequestKey = requestKey;
    store.state.GlobaLoading = true
    store.commit('UpdateChatWinData', [])
  }

  if (appendOlder) {
    store.commit('UpdateChatLoadingMore', true)
  }

  //// отправляем себе на пушер то что у нас открыта эта комната и что не слать в нее пуш
  if (!appendOlder) {
    sendActiveRoom(roomid);
  }

  let json = {
    'pathUrl': store.state.urlPathAuth,  /// путь
    'method': 'get',
    'alert': false,
    'url': 'message',
    'loading': false,
    'postData': {
      'roomid': roomid,
      'before_id': beforeId
    }
  }
  return store.dispatch('axiosData', json)
    .then(res => {
      if (!appendOlder && latestChatRequestKey !== requestKey) {
        if (!silentLoading && latestBlockingChatRequestKey === requestKey) {
          store.state.GlobaLoading = false;
        }
        return res;
      }

      if (!appendOlder) {
        persistReadStatus(roomid)
      }

      const payload = res.data || {};
      const messages = Array.isArray(payload.messages) ? payload.messages : [];
      const hasMore = !!payload.hasMore;

      if (appendOlder) {
        store.commit('UpdateChatWinData', messages.concat(store.state.ChatWinData || []))
      } else {
        store.commit('UpdateChatWinData', messages)
      }

      store.commit('UpdateChatHasMore', hasMore)

      if (res.data.error) {
        //this.ZeroData = res.data.error
        alert(res.data.error)
      }

      if (!appendOlder && autoScroll && Vue.prototype.$eventBus) {
        Vue.prototype.$eventBus.$emit(
          "scrollToBottom",
          silentLoading ? 0 : 1000,
          false
        );
      }


      if (!appendOlder && !silentLoading) {
        store.state.GlobaLoading = false
        if (latestBlockingChatRequestKey === requestKey) {
          latestBlockingChatRequestKey = null;
        }
      }

      if (appendOlder) {
        store.commit('UpdateChatLoadingMore', false)
      }


      ///  возле чате стираем цифру с количеством непрочитанных сообщений
      if (!appendOlder) {
        clearRoomUnreadCount(roomid)
        closeRoomNotifications(roomid)
      }

    })
    .catch(error => {
      if (!appendOlder && latestChatRequestKey !== requestKey) {
        if (!silentLoading && latestBlockingChatRequestKey === requestKey) {
          store.state.GlobaLoading = false;
          latestBlockingChatRequestKey = null;
        }
        return null;
      }

      alert("Error")
      console.log(error)
      if (!appendOlder && !silentLoading) {
        store.state.GlobaLoading = false
        if (latestBlockingChatRequestKey === requestKey) {
          latestBlockingChatRequestKey = null;
        }
      }
      if (appendOlder) {
        store.commit('UpdateChatLoadingMore', false)
      }

      return null;
    })

}

function buildForwardMessagePayload(targetRoomId) {
  const forwardMessage = store.state.ForwardMessage;

  if (!forwardMessage || !forwardMessage._id) {
    return null;
  }

  return buildForwardMessagePayloadFromData(forwardMessage, targetRoomId);
}

function buildForwardMessagePayloadFromData(forwardMessage, targetRoomId) {
  if (!forwardMessage || !forwardMessage._id) {
    return null;
  }

  const sourceRoomId = String(forwardMessage.roomId || '');
  const plainContent = forwardMessage.content
    ? decodeMessage(forwardMessage.content, sourceRoomId)
    : '';

  return {
    _id: forwardMessage._id,
    roomId: forwardMessage.roomId,
    senderId: forwardMessage.senderId,
    username: forwardMessage.username,
    content: plainContent ? encodeMessage(plainContent, String(targetRoomId)) : '',
    hasFiles: Array.isArray(forwardMessage.files) ? forwardMessage.files.length > 0 : !!forwardMessage.hasFiles,
    time: forwardMessage.time || null,
  };
}

export function loadOlderMessages(roomid) {
  if (!roomid || store.state.ChatLoadingMore) {
    return Promise.resolve(null);
  }

  const oldestMessage = Array.isArray(store.state.ChatWinData) && store.state.ChatWinData.length
    ? store.state.ChatWinData[0]
    : null;

  if (!oldestMessage || !oldestMessage._id) {
    return Promise.resolve(null);
  }

  return getMessage(roomid, {
    silentLoading: true,
    beforeId: oldestMessage._id,
    appendOlder: true,
  });
}

//// отправляем себе на пушер то что у нас открыта эта комната и что не слать в нее пуш

export async function sendActiveRoom(roomId) {
  if (!("serviceWorker" in navigator) || !isPushFeatureAvailable()) {
    return;
  }

  try {
    const registration = await getFirebaseMessagingServiceWorkerRegistration();
    const worker = registration?.active || registration?.waiting || registration?.installing;
    const isMobileViewport =
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(max-width: 959px)").matches;
    const isVisible =
      typeof document !== "undefined" &&
      document.visibilityState === "visible" &&
      (
        isMobileViewport ||
        typeof document.hasFocus !== "function" ||
        document.hasFocus()
      );

    if (!worker) {
      console.warn("firebase-messaging-sw.js ещё не готов к получению roomId");
      return;
    }

    console.log("Отправка roomId:", roomId);
    worker.postMessage({
      type: "SET_ACTIVE_ROOM",
      roomId: roomId ?? null,
      isVisible,
    });
  } catch (error) {
    console.error("Не удалось подготовить firebase-messaging-sw.js:", error);
  }
}

export async function closeRoomNotifications(roomId) {
  if (!roomId || !("serviceWorker" in navigator) || !isPushFeatureAvailable()) {
    return;
  }

  try {
    const registration = await getFirebaseMessagingServiceWorkerRegistration();
    const worker = registration?.active || registration?.waiting || registration?.installing;

    if (!worker) {
      return;
    }

    worker.postMessage({
      type: "CLOSE_ROOM_NOTIFICATIONS",
      roomId: roomId ?? null,
    });
  } catch (error) {
    console.warn("Не удалось закрыть уведомления комнаты:", error);
  }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function getCurrentRouteRoomId() {
  if (typeof window === "undefined" || !window.location) {
    return null;
  }

  const match = window.location.pathname.match(/^\/room\/(\d+)$/);
  return match ? match[1] : null;
}

function getActiveRoomContext() {
  const routeRoomId = getCurrentRouteRoomId();

  if (routeRoomId) {
    const routeRoom =
      (store.state.Rooms || []).find((room) => String(room.roomId) === String(routeRoomId)) ||
      null;

    if (routeRoom) {
      return routeRoom;
    }

    if (store.state.RoomOpen && String(store.state.RoomOpen.roomId) === String(routeRoomId)) {
      return store.state.RoomOpen;
    }
  }

  return store.state.RoomOpen || null;
}

export async function sendMessage(text) {
  const activeRoom = getActiveRoomContext();

  if (!activeRoom || !activeRoom.roomId) {
    throw new Error("Не удалось определить активный чат");
  }

  // 1. Ставим флаг загрузки
  //store.state.GlobaLoading = true;

  //// очищаем циферки возле пользователя
  clearUnreadCounter(activeRoom.roomId)
  ///const message = encodeMessage(text.trim(), String(store.state.RoomOpen.roomId));

  /// пишем локальное сообщение
  if (!text && store.state.sendFilesChat.length > 0) {
    text = 'Вложение'
  }

  const messageEncode = encodeMessage(
    text.trim(),
    String(activeRoom.roomId)
  )

  /// узнаем _id кто в группе
  const ids = (activeRoom.users || []).map(m => m._id);


  const tmpId = Date.now();
  const forwardPayload = buildForwardMessagePayload(activeRoom.roomId);
  /// пишем сразу сразу
  const messageTmp = {
    avatar: store.state.UserData.avatar,
    content: messageEncode,
    time: tmpId,
    failure: false,
    files: null,
    replyMessage: store.state.ReplyMessage ? JSON.stringify(store.state.ReplyMessage) : null,
    forwardMessage: forwardPayload ? JSON.stringify(forwardPayload) : null,
    roomId: activeRoom.roomId,
    room_name: activeRoom.roomName || activeRoom.name || "",
    status: "sent",
    senderId: store.state.UserData.user.id,
    type: "mes",
    username: store.state.UserData.user.fio,
    unread_user_ids: ids,
    read_user_ids: [],
    _id: tmpId,
  };
  store.state.ChatWinData.push(messageTmp);

  if (Vue.prototype.$eventBus) {
    Vue.prototype.$eventBus.$emit("scrollToBottom", 0, true);
  }

  /////////////////////////////////////////////
  let formData = new FormData();

  formData.append("roomid", activeRoom.roomId);
  formData.append("repost", 0);
  formData.append("content", messageEncode);

  if (store.state.ReplyMessage) {
    formData.append("replyMessage", JSON.stringify(store.state.ReplyMessage));
  }

  if (forwardPayload) {
    formData.append("forwardMessage", JSON.stringify(forwardPayload));
  }

  if (store.state.sendFilesChat.length > 0) {
    for (let file of store.state.sendFilesChat) {
      formData.append("files[]", file);
    }
  }

  // 2. ВОЗВРАЩАЕМ axios (это создаст Promise)

  const response = await axios.post(store.state.urlPathAuth + "/sendmessage", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + store.state.UserData.access_token,
    },
  });

  if (response.data.success == 1) {
    const botParticipant = getBotParticipant(activeRoom);

    if (botParticipant) {
      setLocalTypingState(
        activeRoom.roomId,
        botParticipant._id,
        botParticipant.username || activeRoom.roomName || "AI",
        true
      );
    }

    // Очищаем стейт только при успехе
    store.commit('UpdateSendTextChat', '');
    store.commit('UpdateSendFilesChat', []);
    if (store.state.ReplyMessage) store.state.ReplyMessage = null;
    if (store.state.ForwardMessage) store.commit("UpdateForwardMessage", null);

    updateMessage(tmpId, response.data.message_id, response.data.files, messageEncode)


    return response.data; // Успех
  } else {
    // Бросаем ошибку, если success != 1 (например, ошибка сервера)
    throw new Error(response.data.error || "Ошибка сервера");
  }

}

function updateRoomPreviewAfterSend(roomId, messageEncode) {
  var ind = store.state.Rooms.findIndex(function (room) {
    return String(room.roomId) === String(roomId);
  });

  if (ind === -1) {
    return;
  }

  var roomCopy = Object.assign({}, store.state.Rooms[ind]);
  var lastMsgData = {
    fio: 'user',
    content: messageEncode
  };

  roomCopy.lastMessage = JSON.stringify(lastMsgData);
  roomCopy.lastMessageAt = Date.now();

  Vue.set(store.state.Rooms, ind, roomCopy);

  var updatedRoom = store.state.Rooms.splice(ind, 1)[0];
  store.state.Rooms.unshift(updatedRoom);
}

export async function forwardMessageToRoom(sourceMessage, targetRoom) {
  if (!sourceMessage || !sourceMessage._id) {
    throw new Error("Нет сообщения для пересылки");
  }

  if (!targetRoom || !targetRoom.roomId) {
    throw new Error("Не выбран чат для пересылки");
  }

  const targetRoomId = targetRoom.roomId;
  const forwardPayload = buildForwardMessagePayloadFromData({
    _id: sourceMessage._id,
    roomId: sourceMessage.roomId || store.state.RoomOpen?.roomId || null,
    senderId: sourceMessage.senderId,
    username: sourceMessage.username,
    content: sourceMessage.content,
    hasFiles: Array.isArray(sourceMessage.files) ? sourceMessage.files.length > 0 : false,
    time: sourceMessage.time || null,
  }, targetRoomId);

  if (!forwardPayload) {
    throw new Error("Не удалось подготовить пересылку");
  }

  const previewContent = forwardPayload.content || encodeMessage("Вложение", String(targetRoomId));

  let formData = new FormData();
  formData.append("roomid", targetRoomId);
  formData.append("repost", 0);
  formData.append("content", forwardPayload.hasFiles ? "" : forwardPayload.content);
  formData.append("forwardMessage", JSON.stringify(forwardPayload));

  const response = await axios.post(store.state.urlPathAuth + "/sendmessage", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + store.state.UserData.access_token,
    },
  });

  if (response.data.success == 1) {
    updateRoomPreviewAfterSend(targetRoomId, previewContent);

    if (store.state.RoomOpen && String(store.state.RoomOpen.roomId) === String(targetRoomId)) {
      await getMessage(targetRoomId, {
        silentLoading: true,
        autoScroll: true,
      });
    }

    return response.data;
  }

  throw new Error(response.data.error || "Ошибка пересылки сообщения");
}

export async function editMessage(text) {
  const editingMessage = store.state.EditMessage;
  if (!editingMessage) {
    return null;
  }

  const trimmedText = String(text || "").trim();
  if (!trimmedText) {
    throw new Error("Пустое сообщение нельзя сохранить");
  }

  const messageEncode = encodeMessage(
    trimmedText,
    String(store.state.RoomOpen.roomId)
  );

  const json = {
    pathUrl: store.state.urlPathAuth,
    method: "put",
    alert: false,
    url: "message",
    loading: false,
    postData: {
      mid: editingMessage._id,
      roomid: store.state.RoomOpen.roomId,
      content: messageEncode,
    },
  };

  const response = await store.dispatch("axiosData", json);

  if (response.data.success == 1 || response.data.success === true) {
    applyLocalMessageEdit(
      editingMessage._id,
      store.state.RoomOpen.roomId,
      messageEncode
    );

    store.commit("UpdateEditMessage", null);
    store.commit("UpdateSendTextChat", "");

    sendStatusMessage(
      "editMessage",
      store.state.RoomOpen.roomId,
      store.state.UserData.user.id,
      editingMessage._id,
      messageEncode
    );

    return response.data;
  }

  throw new Error(response.data.error || "Ошибка редактирования сообщения");
}

export async function toggleMessageReaction(message, reaction) {
  if (!message || !message._id || !store.state.RoomOpen || !store.state.RoomOpen.roomId) {
    return null;
  }

  const json = {
    pathUrl: store.state.urlPathAuth,
    method: "post",
    alert: false,
    url: "message/reaction",
    loading: false,
    postData: {
      mid: message._id,
      roomid: store.state.RoomOpen.roomId,
      reaction: reaction,
    },
  };

  const response = await store.dispatch("axiosData", json);

  if (response.data.success == 1 || response.data.success === true) {
    applyLocalMessageReactions(message._id, response.data.reactions);
    return response.data;
  }

  throw new Error(response.data.error || "Ошибка реакции на сообщение");
}


function updateMessage(tempId, newId, files, messageEncode) {
  // 1. Находим индекс элемента (это надежнее для обновлений)
  const index = store.state.ChatWinData.findIndex(m => m._id === tempId);

  if (index !== -1) {
    const msg = store.state.ChatWinData[index];

    // 2. Обновляем ID и статус реактивно
    msg._id = newId;
    msg.status = "delivered";
    msg.files = files;
    /// msg.lastMessageAt  = new Date;

    // 3. Если этот id используется как :key в v-for, 
    // лучше уведомить Vue об обновлении всего объекта в массиве
    Vue.set(store.state.ChatWinData, index, { ...msg });

    console.log('sent');

    updateRoomPreviewAfterSend(store.state.RoomOpen.roomId, messageEncode);


    setTimeout(() => {
      /// это при отправке сообщения
      if (Vue.prototype.$eventBus) {
        Vue.prototype.$eventBus.$emit("scrollToBottom", 0, true);
      }
    }, 300);

  }
}

export function syncRoomPreviewFromChat(roomId) {
  const roomIndex = store.state.Rooms.findIndex((room) => String(room.roomId) === String(roomId));

  if (roomIndex === -1) {
    return;
  }

  const visibleMessages = (Array.isArray(store.state.ChatWinData) ? store.state.ChatWinData : [])
    .filter((message) => Number(message?.DeleteMessage || 0) !== 2);

  const lastMessage = visibleMessages.length ? visibleMessages[visibleMessages.length - 1] : null;
  const roomCopy = { ...store.state.Rooms[roomIndex] };

  if (lastMessage) {
    roomCopy.lastMessage = JSON.stringify({
      fio: lastMessage.username || 'user',
      content: lastMessage.content || '',
    });
    roomCopy.lastMessageAt = lastMessage.time || Date.now();
  } else {
    roomCopy.lastMessage = null;
    roomCopy.lastMessageAt = null;
  }

  Vue.set(store.state.Rooms, roomIndex, roomCopy);

  if (store.state.RoomOpen && String(store.state.RoomOpen.roomId) === String(roomId)) {
    store.commit('UpdateRoomOpen', roomCopy);
  }
}


// export function sendMessage(text) {

//     // if (store.state.SelectedRoom == 0) {
//     //     alert("Надо выбрать чат"); return;
//     // }

//     store.state.GlobaLoading = true
//     // console.log(store.state.UsersInRoom);
//     /// определяем пользователей в сети но у которых не открыт чат
//     // store.state.UserOnline
//     // let obj = [{ id: 1, name: 'abc' }, { id: 2, name: 'abc' }, { id: 3, name: 'abc' }, { id: 4, name: 'abc' } ];
//     // let idArr = [1, 2]
//     //store.state.UserOnline
//     // let DontSendMesIDs = store.state.UserOnline.filter(item => store.state.UsersInRoom.includes(item.id))



//     //DontSendMesIDs = data

//     /// это список пользователей которы в онлайн в этой группе
//     //const SendWeSocMesIDs = [];

//     // store.state.UsersInRoomOnline.forEach((element) => {
//     //     //DontSendMesIDs = element.id
//     //     if (store.state.UserData.user.id !== element.id)
//     //         SendWeSocMesIDs.push(element.id);

//     //     //SendWeSocMesIDs.push(element.id)
//     // });

//     //console.log(SendWeSocMesIDs);presence.1

//     const message = encodeMessage(text.trim(), String(store.state.RoomOpen.roomId))

//     let formData = new FormData();

//     formData.append("roomid", store.state.RoomOpen.roomId);
//     formData.append("repost", 0);
//     formData.append("content", message);
//     //formData.append("SendWeSocMesIDs", JSON.stringify(UsersInRoomLoc())); /// это массив пользователей онлайн которым отправить сообщение по сокету

//     if (store.state.ReplyMessage) {
//         formData.append("replyMessage", JSON.stringify(store.state.ReplyMessage));
//     }

//     if (store.state.sendFilesChat.length > 0) {
//         for (let file of store.state.sendFilesChat) {
//             formData.append("files[]", file);
//         }
//     }

//     axios
//         .post(store.state.urlPathAuth + "/sendmessage", formData, {
//             headers: {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: "Bearer " + store.state.UserData.access_token,
//             },
//         })
//         .then((response) => {
//             if (response.data.success == 1) {

//                 //console.log(response.data);


//                 store.commit('UpdateSendTextChat', '')
//                 store.commit('UpdateSendFilesChat', [])

//                 store.state.GlobaLoading = false

//                 //this.CloseWin();

//                 if (store.state.ReplyMessage) store.state.ReplyMessage = null;
//                 //this.getUserPhotos()
//                 //this.$eventBus.$emit('getUserInfo')
//             } else if (response.data.error) {
//                 alert(response.data.error);
//             } else {
//                 alert("хз");
//             }

//             //this.loading = false;
//         })
//         .catch((error) => {
//             ////this.loading = false;
//             store.state.GlobaLoading = false
//             alert(error);
//         });
//     // }
// }


export function encodeMessage(message, roomId) {
  const key = String(roomId)

  const encoded = message
    .split('')
    .map((char, i) =>
      String.fromCharCode(
        char.charCodeAt(0) ^ key.charCodeAt(i % key.length)
      )
    )
    .join('')

  return safeBtoa(encoded)
}

export function decodeMessage(encoded, roomId) {
  const key = String(roomId)
  const decoded = safeAtob(encoded)

  return decoded
    .split('')
    .map((char, i) =>
      String.fromCharCode(
        char.charCodeAt(0) ^ key.charCodeAt(i % key.length)
      )
    )
    .join('')
}

function safeBtoa(str) {
  return btoa(
    String.fromCharCode(...new TextEncoder().encode(str))
  )
}

function safeAtob(str) {
  try {
    if (!str) return ''

    return new TextDecoder().decode(
      Uint8Array.from(atob(str), c => c.charCodeAt(0))
    )
  } catch (e) {
    console.error('❌ decode error:', str)
    return str // вернуть как есть
  }
}


function clearUnreadCounter(roomId) {
  // 1. Находим индекс комнаты
  const ind = store.state.Rooms.findIndex(el => el.roomId === roomId);

  if (ind !== -1) {
    // 2. Делаем копию объекта комнаты
    let roomCopy = { ...store.state.Rooms[ind] };

    // 3. Обнуляем в корне
    roomCopy.unreadCount = 0;

    // 4. Обнуляем внутри JSON в lastMessage (если вы храните его и там)
    if (roomCopy.lastMessage) {
      try {
        let lastMsgObj = JSON.parse(roomCopy.lastMessage);
        lastMsgObj.unreadCount = 0;
        roomCopy.lastMessage = JSON.stringify(lastMsgObj);
      } catch (e) {
        console.error("Ошибка парсинга lastMessage при очистке", e);
      }
    }

    // 5. Сохраняем реактивно
    Vue.set(store.state.Rooms, ind, roomCopy);
  }
}
/// получаем массив пользователей которые онлайн глобально и не онлайн локально
// function UsersInRoomLoc() {
//     let UserRes = [];
//     let UserOnlineThisRoomIDs = [];
//     //let ty

//     if (store.state.RoomOpen) {
//         /// пользователи которые онлайн в этой комнате ID
//         store.state.UsersInRoomOnline.forEach((user) => {
//             //UserOnlineThisRoomIDs[user.id] = user.id
//             UserOnlineThisRoomIDs.push(user.id);
//         });

//         ///
//         store.state.RoomOpen.users
//             .filter(
//                 (element) =>
//                     element.status.state == "online" &&
//                     !UserOnlineThisRoomIDs.includes(element._id)
//             )
//             .forEach((item) => {
//                 //UserRes.push([['id',item._id],['username',item.username]]);
//                 UserRes.push({
//                     id: item._id,
//                     username: item.username,
//                     roomId: store.state.RoomOpen.roomId,
//                     avatar: store.state.UserData.avatar,
//                 });

//                 //UserRes = [...UserRes]
//             });
//     }

//     return UserRes;
// }
